import { assert } from '@fe/core';

export class Scale {
    private min = 0;
    private max = 1;

    setLimits(min: number, max: number) {
        assert(min < max);
        this.min = min;
        this.max = max;
    }

    project(value: number) {
        return (value - this.min) / (this.max - this.min);
    }

    unproject(value: number) {
        return this.min + value * (this.max - this.min);
    }

    getMinMax(): [number, number] {
        return [this.min, this.max];
    }

    getMin() {
        return this.min;
    }

    getMax() {
        return this.max;
    }
}
